<div #container class="container">
  <a class="expand-btn" (click)="toggleExpand()">
    <div class="inline-icon arrow" inlineSVG="expand_less.svg" [ngClass]="expanded ? 'not-expand' : 'expand'"></div>
  </a>
  <ng-container *ngIf="!displaySummary then viewGroup  else viewGroupStatus"></ng-container>
  <ng-template #viewGroup>
    <div #infocontainer class="info-container" (click)="navigateToGroupOrder()">
      <span langkey="phRemoteOrder_Home_Button_Text" class="text"></span>
      <span class="text">{{groupManageData.groupName}}</span>
      <span class="text" [innerHTML]="endTimeInfoLabel"></span>
      <div class="icon">
        <div id="header-icon-basket" class="inline-icon" inlineSVG="hypersoft-user-multi.svg"></div>
      </div>
      <div class="basket">
        <span class="text" [innerHTML]="setBasketItemsInfo(itemsCount$|async)"></span>
        <span class="text">{{priceFormatter(totalPrice$|async)}}</span>
      </div>
    </div>
  </ng-template>
  <ng-template #viewGroupStatus>
    <div #infocontainer class="info-container" (click)="navigateToGroupSummary()">
      <div class="icon">
        <div id="header-icon-basket" class="inline-icon" inlineSVG="hypersoft-user-multi.svg"></div>
      </div>
      <span langkey="phRemoteOrder_Home_Button_Info" class="text"></span>
      <span class="text details" langkey="phRemoteOrder_Home_Button_Info_View_Details"></span>
    </div>
  </ng-template>
</div>